import { Overlay, OverlayRef } from '@angular/cdk/overlay';
import { TemplatePortal } from '@angular/cdk/portal';
import {
  Component,
  TemplateRef,
  ViewChild,
  ViewContainerRef,
} from '@angular/core';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import {
  PermissionCheckerService,
  PershingTranslationService,
} from '@pershing/pershing-core';
import { ContactUsBaseComponent } from './contact-us-base.component';

@Component({
  selector: 'contact-us-adaptive',
  templateUrl: './contact-us-adaptive.component.html',
})
export class ContactUsAdaptiveComponent extends ContactUsBaseComponent {
  @ViewChild('advisorPanel') advisorPanel: TemplateRef<any>;
  overlayRef: OverlayRef;

  constructor(
    protected override dialog: MatDialog,
    protected override authorizationService: PermissionCheckerService,
    protected override translationService: PershingTranslationService,
    private overlay: Overlay,
    private viewContainerRef: ViewContainerRef
  ) {
    super(dialog, authorizationService, translationService);
  }
  openOverlay(): void {
    this.overlayRef = this.overlay.create({
      positionStrategy: this.overlay
        .position()
        .global()
        .centerHorizontally()
        .centerVertically(),
      scrollStrategy: this.overlay.scrollStrategies.block(),
      hasBackdrop: true,
    });
    this.overlayRef.attach(
      new TemplatePortal(this.advisorPanel, this.viewContainerRef)
    );
    this.overlayRef.backdropClick().subscribe(() => {
      this.overlayRef.dispose();
    });
  }
}
